import { makeStyles } from "tss-react/mui";
const styles = makeStyles()((theme)=>({
        buttonPrimaryIconOnly: {
            '&.MuiButton-sizeLarge:not(.Mui-disabled)': {
                backgroundColor: theme.tokens.colors.original.brand.primary,
                color: theme.tokens.colors.original.brand.primary,
                '&:hover:not(.buttonLoading)': {
                    backgroundColor: theme.tokens.colors.original.brand.tertirary,
                    color: theme.tokens.colors.original.brand.tertirary
                }
            }
        }
    }));
const SendButton_styles = styles;
export default SendButton_styles;
